import { connect } from 'react-redux';

import DeleteModal from 'components/Erm/Actions/DeleteModal';

import { setCloseGlobalModal } from 'store/GlobalModal/actionCreators';
import { deleteRelationship } from 'store/Erm/Relationship/actionCreators';
import { AppState } from 'store/types';

const mapStateToProps = (state: AppState) => {
    const modal = state.globalModal;
    return {
        modalPayload: modal && modal.payload ? modal.payload : {},
        text: `Are you sure that you're going to delete this relationship?`,
    };

};

const mapDispatchToProps = {
    deleteAction: deleteRelationship,
    closeModal: setCloseGlobalModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal);
